module.exports = __webpack_public_path__ + "media/images/boxed-bg-b6a91122eca33b3e3b457ed8a220add3.jpg";